import { useAtomValue } from 'jotai';

import { TranscriptionPill } from '../../session/TranscriptionPill';
import { patientConsentAtom, providerConsentAtom } from '../../session/messages/state';
import { ConsentStatus, participantCountAtom } from '../../video-sdk';
import { useRecordingControl } from './useRecordingControl';

export function TranscriptionPillWrapper() {
  const patientConsent = useAtomValue(patientConsentAtom).value;
  const providerConsent = useAtomValue(providerConsentAtom).value;
  const hasMultipleParticipants = useAtomValue(participantCountAtom) > 1;

  const { isVisible, isRecording } = useRecordingControl();

  const bothPartiesConsented = patientConsent === ConsentStatus.OPTED_IN && providerConsent === ConsentStatus.OPTED_IN;

  if (!isVisible || !(bothPartiesConsented || isRecording) || hasMultipleParticipants) {
    return null;
  }

  return <TranscriptionPill isRecording={isRecording} patientConsent={patientConsent} />;
}
